import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TableCell, TableRow, Chip } from '@mui/material'

import {
  TableMenuButtonComponent,
  TableMenuComponent,
  TableMenuOptions,
} from '@/views/components'
import { RoleType } from '@/enums'
import useHasAccess from '@/hooks/use-access.hook'

import { ExcludedGamesColumnProps } from '@/views/bonus-engine/hooks/types'

type Props = {
  row: ExcludedGamesColumnProps
  handleEditGame: (gameId: string, gameProviderId: string) => void
  handleDeleteGame: (
    gameId: string,
    gameProviderId: string,
    anchorPosition: {
      top: number
      left: number
    },
  ) => void
}

export const ExcludedGamesRowComponent = ({
  row,
  handleDeleteGame,
  handleEditGame,
}: Props) => {
  const { t } = useTranslation()

  const { hasAccess } = useHasAccess()

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const canDelete = !hasAccess(RoleType.AGENT) && !row.isBlocked

  const canEdit = !hasAccess(RoleType.AGENT)

  const handleClickButton = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    type: TableMenuOptions,
  ) => {
    const anchorPosition = {
      top: anchorEl?.getBoundingClientRect().top || event.clientY,
      left: anchorEl?.getBoundingClientRect().left || event.clientX,
    }
    type === 'delete' &&
      handleDeleteGame(
        row.gameId.toString(),
        row.gameProviderId.toString(),
        anchorPosition,
      )
    type === 'edit' &&
      handleEditGame(row.gameId.toString(), row.gameProviderId.toString())

    setAnchorEl(null)
  }

  return (
    <>
      <TableRow hover role="checkbox">
        <TableCell>
          <Chip
            variant="filled"
            size="medium"
            label={t(`${row.isBlocked ? 'labels.true' : 'labels.false'}`)}
            className={`${row.isBlocked ? 'green' : 'red'}`}
            sx={{ width: '100%' }}
          />
        </TableCell>
        <TableCell>{row.gameDescription}</TableCell>
        <TableCell>{row.gameId}</TableCell>
        <TableCell>{row.gameProviderId}</TableCell>
        <TableMenuButtonComponent setAnchorEl={setAnchorEl} />
      </TableRow>
      <TableMenuComponent
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        handleClickButton={handleClickButton}
        canDelete={canDelete}
        canEdit={canEdit}
      />
    </>
  )
}
